"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolisClient = void 0;
var axios_1 = __importDefault(require("axios"));
var erros_1 = __importStar(require("../provider/erros"));
var ethers_1 = require("ethers");
var polisProvider_1 = require("../provider/polisProvider");
var PolisOauth2Client_1 = require("../provider/PolisOauth2Client");
var request_1 = __importDefault(require("../request"));
var metamask_1 = require("../metamask");
var wallectConnector_1 = __importDefault(require("../provider/wallectConnector"));
var log_1 = __importDefault(require("../provider/utils/log"));
var utils_1 = require("../provider/utils");
var PolisClient = /*#__PURE__*/function () {
  function PolisClient(opts) {
    _classCallCheck(this, PolisClient);
    this._confirmUrL = '';
    this._apiHost = '';
    this._oauthLoginuRL = '';
    this._appId = '';
    this._chainId = -1;
    if (opts.apiHost) {
      this._apiHost = opts.apiHost;
    } else {
      this._apiHost = 'https://polis.metis.io/';
    }
    this._appId = opts.appId;
    this.chainId = opts.chainId;
    if (!this._apiHost.endsWith('/')) {
      this._apiHost = this._apiHost + '/';
    }
    if (!!!this._ethProvider) {
      this.initProvider({
        apiHost: this.apiHost,
        chainId: this.chainId,
        token: this.token,
        debug: opts.debug
      });
    }
    var self = this;
  }
  _createClass(PolisClient, [{
    key: "apiHost",
    get: function get() {
      return this._apiHost;
    },
    set: function set(value) {
      this._apiHost = value;
    }
  }, {
    key: "chainId",
    get: function get() {
      return this._chainId;
    },
    set: function set(value) {
      this._chainId = value;
    }
  }, {
    key: "token",
    get: function get() {
      var _a;
      return (_a = this._authInfo) === null || _a === void 0 ? void 0 : _a.accessToken;
    }
  }, {
    key: "appId",
    get: function get() {
      return this._appId;
    }
  }, {
    key: "confirmUrl",
    get: function get() {
      return "".concat(this.apiHost, "#/oauth2/confirm");
    }
  }, {
    key: "oauthLoginUrl",
    get: function get() {
      return "".concat(this.apiHost, "#/oauth2-login?");
    }
  }, {
    key: "oauthInfo",
    get: function get() {
      return this._authInfo;
    }
  }, {
    key: "web3Provider",
    get: function get() {
      if (!!this._ethProvider) {
        return this._ethProvider;
      }
      throw erros_1.default.PROVIDER_IS_NOT_INIT;
    }
  }, {
    key: "startOauth2",
    value: function startOauth2(opts) {
      if (!!!this.apiHost || this.apiHost.length <= 0) {}
      if (!!!opts.appId || opts.appId.length <= 0) {}
      if (!!!opts.returnUrl || opts.returnUrl.length <= 0) {}
      this._appId = opts.appId;
      var loginUrl = "".concat(this.oauthLoginUrl, "switch_account=").concat(opts.switchAccount, "&app_id=").concat(this.appId, "&return_url=").concat(encodeURIComponent(opts.returnUrl));
      window.location.replace(loginUrl);
      return null;
    }
  }, {
    key: "connect",
    value: function connect(auth) {
      var bridgeTx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var needWcSession, wcProvider, _wcProvider;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              needWcSession = false;
              if (!(auth && auth.accessToken)) {
                _context.next = 21;
                break;
              }
              auth.expriesAt = new Date().getTime() + (auth.expiresIn - 5) * 1000;
              this._authInfo = auth;
              this._polisOauthClient = new PolisOauth2Client_1.PolisOauth2Client(this.apiHost, this.appId, auth);
              if (bridgeTx) {
                _context.next = 9;
                break;
              }
              _context.next = 8;
              return this.saveWCSession();
            case 8:
              needWcSession = _context.sent;
            case 9:
              if (!this._polisprovider) {
                _context.next = 19;
                break;
              }
              this._polisprovider.connect(auth.accessToken, bridgeTx, needWcSession);
              if (!needWcSession) {
                _context.next = 18;
                break;
              }
              _context.next = 14;
              return wallectConnector_1.default.getWalletConnectProvider();
            case 14:
              wcProvider = _context.sent;
              this._ethProvider = new ethers_1.ethers.providers.Web3Provider(wcProvider, 'any');
              _context.next = 19;
              break;
            case 18:
              this._ethProvider = new ethers_1.ethers.providers.Web3Provider(this._polisprovider, 'any');
            case 19:
              _context.next = 41;
              break;
            case 21:
              if (!(typeof auth == "string")) {
                _context.next = 39;
                break;
              }
              if (this._authInfo) {
                this._authInfo.accessToken = auth;
              } else {
                this._authInfo = {
                  appId: this.appId,
                  accessToken: auth,
                  refreshToken: "",
                  expiresIn: 0,
                  expriesAt: 0
                };
              }
              if (!this._polisprovider) {
                _context.next = 37;
                break;
              }
              if (bridgeTx) {
                _context.next = 28;
                break;
              }
              _context.next = 27;
              return this.saveWCSession();
            case 27:
              needWcSession = _context.sent;
            case 28:
              this._polisprovider.connect(auth, bridgeTx, needWcSession);
              if (!needWcSession) {
                _context.next = 36;
                break;
              }
              _context.next = 32;
              return wallectConnector_1.default.getWalletConnectProvider();
            case 32:
              _wcProvider = _context.sent;
              this._ethProvider = new ethers_1.ethers.providers.Web3Provider(_wcProvider, 'any');
              _context.next = 37;
              break;
            case 36:
              this._ethProvider = new ethers_1.ethers.providers.Web3Provider(this._polisprovider, 'any');
            case 37:
              _context.next = 41;
              break;
            case 39:
              this.emit("error", 'auth info is empty');
              return _context.abrupt("return", Promise.reject({
                code: 401,
                message: "auth info is empty"
              }));
            case 41:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getContract",
    value: function getContract(contractAddress, abi) {
      if (this._ethProvider != undefined) {
        if (this.token) {
          return new ethers_1.ethers.Contract(contractAddress, abi, this._ethProvider.getSigner());
        } else {
          return new ethers_1.ethers.Contract(contractAddress, abi, this._ethProvider);
        }
      } else {
        this.emit("error", "provider init error");
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var logoutUrl, hostUrl, appId, self, token, refreshToken, res, errMsg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!!!this.oauthInfo && !this.token)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", Promise.reject(erros_1.default.TOKEN_IS_EMPTY));
            case 2:
              logoutUrl = this.apiHost + "#/oauth2-logout";
              hostUrl = this.apiHost;
              appId = this.appId;
              self = this;
              token = (_a = this._authInfo) === null || _a === void 0 ? void 0 : _a.accessToken;
              refreshToken = (_b = this._authInfo) === null || _b === void 0 ? void 0 : _b.refreshToken;
              _context2.next = 10;
              return axios_1.default.get("".concat(this.apiHost, "api/v1/oauth2/logout?app_id=").concat(this.appId, "&token=").concat(token, "&refresh_token=").concat(refreshToken));
            case 10:
              res = _context2.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context2.next = 16;
                break;
              }
              this._authInfo = undefined;
              return _context2.abrupt("return", Promise.resolve(res.data.data));
            case 16:
              if (!(res.status === 200 && res.data.code != 200)) {
                _context2.next = 22;
                break;
              }
              errMsg = res.data.msg;
              this.emit('error', res.data.msg);
              return _context2.abrupt("return", Promise.reject(errMsg));
            case 22:
              this.emit('error', "request url  server error!");
              return _context2.abrupt("return", Promise.reject(res));
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "refreshToken",
    value: function refreshToken(callback) {
      var _this = this;
      var _a, _b;
      if (!!!this.oauthInfo || this.oauthInfo.refreshToken == "") {
        (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.emit('error', erros_1.default.REFRSHTOKEN_IS_EMPTY);
      }
      axios_1.default.get(this.apiHost + "/api/v1/oauth2/refresh_token?app_id=".concat(this.appId, "&refresh_token=").concat((_b = this._authInfo) === null || _b === void 0 ? void 0 : _b.refreshToken)).then(function (res) {
        if (res.status === 200 && res.data && res.data.code === 200) {
          _this.oauthInfo.accessToken = res.data.data.access_token;
          _this.oauthInfo.expiresIn = res.data.data.expires_in;
          _this.oauthInfo.refreshToken = res.data.data.refresh_token;
          _this.oauthInfo.expriesAt = new Date().getTime() + (res.data.data.expires_in - 5) * 1000;
          if (callback) {
            callback(_this.oauthInfo);
          }
        } else if (res.status === 200 && res.data) {
          log_1.default.warn(res.data);
        }
      });
    }
  }, {
    key: "refreshTokenAsync",
    value: function refreshTokenAsync() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!!this.oauthInfo) {
                _context3.next = 3;
                break;
              }
              (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.emit('error', erros_1.default.TOKEN_IS_EMPTY);
              return _context3.abrupt("return", Promise.reject(erros_1.default.TOKEN_IS_EMPTY));
            case 3:
              _context3.next = 5;
              return axios_1.default.get(this.apiHost + "api/v1/oauth2/refresh_token?app_id=".concat(this.appId, "&refresh_token=").concat((_b = this._authInfo) === null || _b === void 0 ? void 0 : _b.refreshToken));
            case 5:
              res = _context3.sent;
              if (!(res.status == 200 && res.data && res.data.code == 200)) {
                _context3.next = 14;
                break;
              }
              this._authInfo.accessToken = res.data.data.access_token;
              this._authInfo.expiresIn = res.data.data.expires_in;
              this._authInfo.refreshToken = res.data.data.refresh_token;
              this._authInfo.expriesAt = new Date().getTime() + (res.data.data.expires_in - 5) * 1000;
              return _context3.abrupt("return", Promise.resolve(this._authInfo));
            case 14:
              if (!(res.status === 200 && res.data)) {
                _context3.next = 17;
                break;
              }
              log_1.default.error(res.data);
              return _context3.abrupt("return", Promise.reject(res.data));
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getUserInfoAsync",
    value: function getUserInfoAsync() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var url, res, errMsg;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.checkOauth()) {
                _context4.next = 3;
                break;
              }
              this.emit('error', erros_1.default.NO_PERMISSION);
              return _context4.abrupt("return", Promise.reject(erros_1.default.NO_PERMISSION));
            case 3:
              url = this.apiHost + "api/v1/oauth2/userinfo";
              _context4.next = 6;
              return axios_1.default.get("".concat(url, "?access_token=").concat((_a = this.oauthInfo) === null || _a === void 0 ? void 0 : _a.accessToken));
            case 6:
              res = _context4.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context4.next = 11;
                break;
              }
              return _context4.abrupt("return", Promise.resolve(res.data.data));
            case 11:
              if (!(res.status === 200 && res.data)) {
                _context4.next = 17;
                break;
              }
              errMsg = res.data.msg;
              this.emit('error', res.data.msg);
              return _context4.abrupt("return", Promise.reject(errMsg));
            case 17:
              this.emit('error', "request url  server error!");
              return _context4.abrupt("return", Promise.reject(res));
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "changeChain",
    value: function changeChain(chainId) {
      var _a;
      (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.emit('changeChain', {
        chainId: chainId
      });
      if (this._polisprovider) this._polisprovider.chainId = chainId;
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      var _a;
      (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.on(event, callback);
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      var _a;
      (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.once(event, callback);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      var _a;
      (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.off(event, callback);
    }
  }, {
    key: "estimateGasAsync",
    value: function estimateGasAsync(domain, chainId, fun, args) {
      var disableTooltip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var extendParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var r, headers, res, trans, errMsg;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              r = new request_1.default(!disableTooltip);
              _context5.prev = 1;
              _context5.next = 4;
              return this.handleRefreshTokenAsync();
            case 4:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.token
              };
              _context5.next = 7;
              return r.instance.post("".concat(this.apiHost, "/api/v1/oauth2/send_tx"), {
                chainId: chainId,
                domain: domain,
                args: args,
                estimateGas: true,
                function: fun,
                extendParams: extendParams
              }, {
                headers: headers
              });
            case 7:
              res = _context5.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context5.next = 13;
                break;
              }
              trans = res.data.data;
              return _context5.abrupt("return", Promise.resolve(trans));
            case 13:
              if (!(res.status === 200 && res.data)) {
                _context5.next = 18;
                break;
              }
              errMsg = res.data.msg;
              return _context5.abrupt("return", Promise.reject((0, erros_1.makeRequestError)(errMsg)));
            case 18:
              return _context5.abrupt("return", Promise.reject((0, erros_1.makeError)(erros_1.default.NETWORK_ERROR, res)));
            case 19:
              _context5.next = 24;
              break;
            case 21:
              _context5.prev = 21;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", Promise.reject((0, erros_1.makeRequestError)(_context5.t0.message)));
            case 24:
              return _context5.abrupt("return", null);
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 21]]);
      }));
    }
  }, {
    key: "getDomain",
    value: function getDomain(name, chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.post('domains', {
                name: name,
                chainId: chainId
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "createDomain",
    value: function createDomain(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.post('domains/create', param, 'post', true));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "saveDomainChains",
    value: function saveDomainChains(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!param.id) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", this.post("domains/".concat(param.id, "/save_chains"), param, 'post', true));
            case 2:
              if (!param.domain) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("return", this.post("domains/".concat(param.domain, "/save_chains"), param, 'post', true));
            case 4:
              return _context8.abrupt("return", Promise.reject('The parameter ID or domain can not be empty'));
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "delDomain",
    value: function delDomain(domain) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.post("deldomain/".concat(domain), null, 'get', true));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "createDapp",
    value: function createDapp(param) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.post('create_applications?access_token=' + this.token, param, 'post', true));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "modifyDapp",
    value: function modifyDapp(param) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.post('modify_applications?access_token=' + this.token, param, 'post', true));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "deleteDapps",
    value: function deleteDapps(param) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.post('del_applications?access_token=' + this.token, param, 'post', true));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "getDappList",
    value: function getDappList(pageSize, pageIndex) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var method;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              method = 'get_applications?' + this.token + "&page_no=" + pageIndex + "&page_size=" + pageSize;
              return _context13.abrupt("return", this.post(method, null, 'get'));
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "getDapp",
    value: function getDapp(dappId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var method;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              method = 'get_application?' + this.token + "&id=" + dappId;
              return _context14.abrupt("return", this.post(method, null, 'get'));
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "applyToDeveloper",
    value: function applyToDeveloper() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var method;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              method = 'dev_request?' + this.token;
              return _context15.abrupt("return", this.post(method, null, 'get'));
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "getChainUrl",
    value: function getChainUrl(chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.post('chainurl', {
                chainId: chainId
              });
            case 2:
              return _context16.abrupt("return", _context16.sent);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "addTokenToMM",
    value: function addTokenToMM(token) {
      var tokenAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tokenDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 18;
      var tokenImage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var chainId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var chainObj, chainNum;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              chainObj = null;
              chainNum = chainId;
              if (typeof token === 'object' && !!token['chainId']) {
                chainNum = token['chainId'];
              }
              if (!(chainNum > 0)) {
                _context17.next = 14;
                break;
              }
              _context17.prev = 4;
              _context17.next = 7;
              return this.getChainUrl("".concat(chainNum));
            case 7:
              chainObj = _context17.sent;
              if (chainObj) {
                chainObj['chainId'] = chainNum;
              }
              _context17.next = 14;
              break;
            case 11:
              _context17.prev = 11;
              _context17.t0 = _context17["catch"](4);
              chainObj = null;
            case 14:
              return _context17.abrupt("return", (0, metamask_1.addToken)(token, tokenAddress, tokenDecimals, tokenImage, chainObj));
            case 15:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this, [[4, 11]]);
      }));
    }
  }, {
    key: "initProvider",
    value: function initProvider(opts) {
      this._polisprovider = new polisProvider_1.PolisProvider(opts, this._polisOauthClient);
      this._ethProvider = new ethers_1.ethers.providers.Web3Provider(this._polisprovider, 'any');
    }
  }, {
    key: "handleRefreshTokenAsync",
    value: function handleRefreshTokenAsync() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!(((_a = this._authInfo) === null || _a === void 0 ? void 0 : _a.expriesAt) > 0 && new Date().getTime() >= ((_b = this._authInfo) === null || _b === void 0 ? void 0 : _b.expriesAt))) {
                _context18.next = 2;
                break;
              }
              return _context18.abrupt("return", this.refreshTokenAsync());
            case 2:
              return _context18.abrupt("return", Promise.resolve(this._authInfo));
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "post",
    value: function post(method, data) {
      var httpMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
      var returnObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var headers, res, result, errMsg;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.handleRefreshTokenAsync();
            case 2:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.token
              };
              if (!(httpMethod === 'post')) {
                _context19.next = 9;
                break;
              }
              _context19.next = 6;
              return axios_1.default.post(this.apiHost + "api/v1/oauth2/" + method, data, {
                headers: headers
              });
            case 6:
              res = _context19.sent;
              _context19.next = 12;
              break;
            case 9:
              _context19.next = 11;
              return axios_1.default.get(this.apiHost + "api/v1/oauth2/" + method, {
                headers: headers
              });
            case 11:
              res = _context19.sent;
            case 12:
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context19.next = 17;
                break;
              }
              result = res.data.data;
              if (!returnObj) {
                _context19.next = 16;
                break;
              }
              return _context19.abrupt("return", Promise.resolve(res.data));
            case 16:
              return _context19.abrupt("return", Promise.resolve(result));
            case 17:
              if (!(res.status === 200 && res.data)) {
                _context19.next = 21;
                break;
              }
              errMsg = res.data.msg;
              this.emit("error", errMsg);
              return _context19.abrupt("return", Promise.reject(errMsg));
            case 21:
              return _context19.abrupt("return", Promise.reject(res.data));
            case 22:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "request",
    value: function request(url, data) {
      var httpMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
      var returnObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var headers, res, result;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.handleRefreshTokenAsync();
            case 2:
              headers = {
                'Content-Type': 'application/json',
                'Authorization': this.token,
                'Access-Token': this.token
              };
              if (!(httpMethod === 'post')) {
                _context20.next = 9;
                break;
              }
              _context20.next = 6;
              return axios_1.default.post(this.apiHost + url, data, {
                headers: headers
              });
            case 6:
              res = _context20.sent;
              _context20.next = 12;
              break;
            case 9:
              _context20.next = 11;
              return axios_1.default.get(this.apiHost + url, {
                headers: headers
              });
            case 11:
              res = _context20.sent;
            case 12:
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context20.next = 17;
                break;
              }
              result = res.data.data;
              if (!returnObj) {
                _context20.next = 16;
                break;
              }
              return _context20.abrupt("return", Promise.resolve(res.data));
            case 16:
              return _context20.abrupt("return", Promise.resolve(result));
            case 17:
              if (!(res.status === 200 && res.data)) {
                _context20.next = 20;
                break;
              }
              this.emit("error", res.data);
              return _context20.abrupt("return", Promise.reject(res.data));
            case 20:
              return _context20.abrupt("return", Promise.reject(res.data));
            case 21:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "checkOauth",
    value: function checkOauth() {
      return !!this._authInfo;
    }
  }, {
    key: "saveWCSession",
    value: function saveWCSession() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var res;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.request("api/v1/oauth2/wc_session", null, 'get', true);
            case 2:
              res = _context21.sent;
              if (!(res.code == 200)) {
                _context21.next = 7;
                break;
              }
              log_1.default.debug("wc_session....res....", res);
              window.localStorage.setItem("walletconnect", res.data.wcSession);
              return _context21.abrupt("return", res.data.walletType == utils_1.WALLET_TYPES.WC);
            case 7:
              return _context21.abrupt("return", false);
            case 8:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "emit",
    value: function emit(name, obj) {
      var _a;
      (_a = this._polisprovider) === null || _a === void 0 ? void 0 : _a.emit(name, obj);
    }
  }]);
  return PolisClient;
}();
exports.PolisClient = PolisClient;
exports.default = PolisClient;